import withNextStep from 'core/libs/hoc/withNextStep';
import NewDesignButton from 'modules/common/NewDesignButton';
import PropTypes from 'prop-types';
import React from 'react';
import {branch, compose, renderNothing} from 'recompose';

const NextButton = ({
  pretext = '',
  nextStep: {url, text},
  className = '',
  completeProgress,
}) => (
  <NewDesignButton
    onClick={completeProgress}
    link={url}
    className={`bg-blue bg-animate hover-bg-dark-blue dib pv2 ph4 white br2 fw6 ${className}`}
    cy="next-step"
  >
    {`${pretext} ${text}`}
  </NewDesignButton>
);

NextButton.propTypes = {
  pretext: PropTypes.string,
  nextStep: PropTypes.object.isRequired,
  className: PropTypes.string,
  completeProgress: PropTypes.func,
};

const enhance = compose(
  withNextStep,
  branch(({nextStep: {text}}) => !text, renderNothing),
);

export default enhance(NextButton);
